import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { apiSlice } from './apiSlice';
import activityReducer from './slices/activitiesSlice';
import authSlice from './slices/authSlice';
import equipmentReducer from './slices/equipmentSlice';
import projectReducer from './slices/projectSlice';
import punchInfoReducer from './slices/punchInfoSlice';
import punchOptionsReducer from './slices/punchOptionsSlice';
import punchReducer from './slices/punchSlice';
import uiSlice from './slices/uiSlice';

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    [authSlice.name]: authSlice.reducer,
    [uiSlice.name]: uiSlice.reducer,
    project: projectReducer,
    punches: punchReducer,
    punchOptions: punchOptionsReducer,
    equipment: equipmentReducer,
    activities: activityReducer,
    punchInfo: punchInfoReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type DispatchType = typeof store.dispatch;

// https://react-redux.js.org/using-react-redux/static-typing#typing-the-useselector-hook
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useTypedDispatch = () => useDispatch<DispatchType>();
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
